var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGetoffer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3969 14.6299C36.365 9.49116 43.635 9.49116 45.6031 14.6299L45.695 14.8698C46.9256 18.0829 50.6006 19.6052 53.7427 18.2033L53.9774 18.0986C59.0027 15.8566 64.1434 20.9973 61.9014 26.0226L61.7967 26.2573C60.3948 29.3994 61.9171 33.0744 65.1302 34.305L65.3701 34.3969C70.5088 36.365 70.5088 43.635 65.3701 45.6031L65.1302 45.695C61.9171 46.9256 60.3948 50.6006 61.7967 53.7427L61.9014 53.9774C64.1434 59.0027 59.0027 64.1434 53.9774 61.9014L53.7427 61.7967C50.6006 60.3948 46.9256 61.9171 45.695 65.1302L45.6031 65.3701C43.635 70.5088 36.365 70.5088 34.3969 65.3701L34.305 65.1302C33.0744 61.9171 29.3994 60.3948 26.2573 61.7967L26.0226 61.9014C20.9973 64.1434 15.8566 59.0027 18.0986 53.9774L18.2033 53.7427C19.6052 50.6006 18.0829 46.9256 14.8698 45.695L14.6299 45.6031C9.49116 43.635 9.49116 36.365 14.6299 34.3969L14.8698 34.305C18.0829 33.0744 19.6052 29.3994 18.2033 26.2573L18.0986 26.0226C15.8566 20.9973 20.9973 15.8566 26.0226 18.0986L26.2573 18.2033C29.3994 19.6052 33.0744 18.0829 34.305 14.8698L34.3969 14.6299Z",
    fill: "#9747FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3 35.92V41.07C47.3 44.15 45.54 45.47 42.9 45.47H34.11C33.66 45.47 33.23 45.43 32.83 45.34C32.58 45.3 32.34 45.23 32.12 45.15C30.62 44.59 29.71 43.29 29.71 41.07V35.92C29.71 32.84 31.47 31.52 34.11 31.52H42.9C45.14 31.52 46.75 32.47 47.18 34.64C47.25 35.04 47.3 35.45 47.3 35.92Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3011 38.9201V44.0701C50.3011 47.1501 48.5411 48.4701 45.9011 48.4701H37.1111C36.3711 48.4701 35.7011 48.3701 35.1211 48.1501C33.9311 47.7101 33.1211 46.8001 32.8311 45.3401C33.2311 45.4301 33.6611 45.4701 34.1111 45.4701H42.9011C45.5411 45.4701 47.3011 44.1501 47.3011 41.0701V35.9201C47.3011 35.4501 47.2611 35.0301 47.1811 34.6401C49.0811 35.0401 50.3011 36.3801 50.3011 38.9201Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4984 41.1399C39.9564 41.1399 41.1384 39.9579 41.1384 38.4999C41.1384 37.0418 39.9564 35.8599 38.4984 35.8599C37.0404 35.8599 35.8584 37.0418 35.8584 38.4999C35.8584 39.9579 37.0404 41.1399 38.4984 41.1399Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.78 36.3V40.7",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2217 36.3003V40.7003",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetoffer);
export default __webpack_public_path__ + "static/media/getoffer.f170e7f2202936b7f36f4c62cec3a777.svg";
export { ForwardRef as ReactComponent };